enum ActStatus {
  DRAFT = "DRAFT",
  APPROVED = "APPROVED",

  //для армении
  DISAGREEMENT = "DISAGREEMENT",
  AGREED = "AGREED",
  SIGNED = "SIGNED",
  EXPIRED = "EXPIRED",
}

export default ActStatus;
